var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReviewsWithHeartIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9998 36.8944C24.5415 36.8944 24.0968 36.8362 23.6726 36.7268L22.2227 37.6935C23.0688 38.0794 24.0092 38.2944 24.9998 38.2944H29.7416L29.4877 41.558C29.3706 43.0635 31.1281 43.963 32.2808 42.9876L37.2253 38.8033C37.6137 38.4747 38.1059 38.2944 38.6146 38.2944H40.9998C44.7001 38.2944 47.6998 35.2947 47.6998 31.5944V20.0008C47.6998 16.3005 44.7001 13.3008 40.9998 13.3008H40.6998V14.7008H40.9998C43.9269 14.7008 46.2998 17.0737 46.2998 20.0008V31.5944C46.2998 34.5215 43.9269 36.8944 40.9998 36.8944H38.6146C37.7748 36.8944 36.9621 37.1921 36.321 37.7346L31.3764 41.9189C31.173 42.091 30.8629 41.9323 30.8835 41.6666L31.1563 38.1606C31.2094 37.4778 30.6696 36.8944 29.9847 36.8944H24.9998Z",
    fill: "#F93749"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M30 5H8C4.68629 5 2 7.68629 2 11V23C2 26.3137 4.68629 29 8 29H30C33.3137 29 36 26.3137 36 23V11C36 7.68629 33.3137 5 30 5Z",
    fill: "#F93749"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6612 24.6691L21 24.8407L21.3388 24.6691C21.7552 24.4583 23.3177 23.6301 24.7869 22.3544C26.2263 21.1044 27.75 19.2743 27.75 17.0474C27.75 14.9962 25.9487 13.25 23.8929 13.25L23.8916 13.25C22.7866 13.2518 21.7313 13.6961 21 14.4708C20.2687 13.6961 19.2134 13.2518 18.1084 13.25H18.1071C16.0513 13.25 14.25 14.9962 14.25 17.0474C14.25 19.2743 15.7737 21.1044 17.2131 22.3544C18.6823 23.6301 20.2448 24.4583 20.6612 24.6691Z",
    stroke: "#F93749",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1073 32.8523C27.1437 32.8523 26.2091 33.1807 25.4586 33.783L18.156 38.7411C17.9901 38.8539 17.7656 38.735 17.7656 38.5343V34.1791C17.7656 33.4437 17.1679 32.8523 16.4366 32.8523H7C4.10051 32.8523 1.75 30.5018 1.75 27.6023V10C1.75 7.10051 4.10051 4.75 7 4.75H34C36.8995 4.75 39.25 7.10051 39.25 10V27.6023C39.25 30.5018 36.8995 32.8523 34 32.8523H28.1073Z",
    stroke: "#F93749",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewsWithHeartIcon);
export default __webpack_public_path__ + "static/media/reviewsWithHeartIcon.45c2a731b020550033176f27e09911ea.svg";
export { ForwardRef as ReactComponent };